module.exports = __webpack_public_path__ + "img/crediCodeImg.963039bf.png";